import { gql } from "@apollo/client";
import { MESSAGE_INFO } from "../fragments";

export const GET_CHAT_ROOM_LIST = gql`
  query getChatRoomList {
    getChatRoomList {
      id
      member {
        id
        memberId
        nickname
        profileImage
        isBlocked
      }
      lastMessage
      createdAt
      updatedAt
      branch {
        id
        name
      }
    }
  }
`;

export const GET_MESSAGES = gql`
  query getAdminMessages($memberId: ID) {
    getAdminMessages(memberId: $memberId) {
      ...messageInfo
    }
  }
  ${MESSAGE_INFO}
`;

export const GET_MESSAGE_NOTIFICATIONS = gql`
  query memberChatNotifications($memberId: ID, $toAdmin: Boolean!) {
    memberChatNotifications(memberId: $memberId, toAdmin: $toAdmin) {
      id
      isRead
      createdAt
      message {
        id
        text {
          message
        }
      }
    }
  }
`;

export const GET_ALL_NOTIFICATIONS = gql`
  query allChatNotifications {
    allChatNotifications
  }
`;
